import { LangType, Translations } from '../shared/typings/lang';
import en from './en.json';
import enCa from './en-ca.json';
import fr from './fr.json';

const translations: Translations = { en, 'en-ca': enCa, fr };

export const translation = (lang: LangType, key: string): string => {
  return translations[lang]?.[key] || translations['en'][key] || key;
};
